Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.AssignedToFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/assigned_to_filter']
  className: 'filter-field-container assigned-to-filter'

  NO_TEAM_AND_NO_OPERATOR_ID = ''

  initialize: ({filter, query, users, groups}) ->
    @filter = filter
    @query = query
    @users = users
    @groups = groups

  render: ->
    @$el.html @template
    @renderAssignedToView()
    @$('.assigned-to-filter').addClass('d-none') if @hideAssignedTo()
    @

  hideAssignedTo: ->
    !@editable && !@query.assigned_to_me && @query.assigned_to_id.length == 0

  renderAssignedToView: ->
    @assignedToView = new Customer.Filters.GroupSelectView(
      title: I18n.t('customer.dashboard.filters.creation.assigned_to')
      options: [
        {
          title: '',
          options: {
            options: [@_notAssigned()],
            valueProperty: 'id',
            descriptionProperty: 'name',
            selectedOptions: @filter.get('query').users_group_id,
            placeholder: I18n.t('customer.dashboard.filters.placeholders.select_item')
          }
        }
        {
          title: I18n.t('customer.dashboard.filters.placeholders.teams'),
          options: {
            options: @_usersGroups(),
            valueProperty: 'id',
            descriptionProperty: 'name',
            selectedOptions: @filter.get('query').users_group_id,
            placeholder: I18n.t('customer.dashboard.filters.placeholders.select_item')
          }
        }
        {
          title: I18n.t('customer.dashboard.filters.placeholders.operators'),
          options: {
            options: @_users(),
            valueProperty: 'id',
            descriptionProperty: 'description',
            width: 'inherit',
            selectedOptions: @_assignedUsers(),
            placeholder: I18n.t('customer.dashboard.filters.placeholders.select_item')
          }
        }
      ])
    @$('#filter-users').append(@assignedToView.el)
    @listenTo(@assignedToView, 'change', @_onChange)

  _onChange: (selectedOption) =>
    @_isolateNoTeamAndNoOperatorOption(selectedOption)
    @trigger('assignedTo:change')

  _isolateNoTeamAndNoOperatorOption: (selectedOption) ->
    if selectedOption && @assignedToView.selectedWithClass('groups').includes(NO_TEAM_AND_NO_OPERATOR_ID)
      @assignedToView.clean()
      @assignedToView.disable()
      @assignedToView.selectByText(I18n.t('customer.dashboard.filters.no_team_nor_operator'))
    else
      @assignedToView.enable()

  _users: ->
    return (@_enhanceUser user for user in [@_meUser(), @_robotUser(), @users...])

  _meUser: ->
    first_name: I18n.t('customer.dashboard.conversations.details.assign.me')
    last_name: ''
    id: 'me'

  _robotUser: ->
    first_name: 'Keepcon'
    last_name: 'Robot'
    id: 'robot'

  _enhanceUser: (user) ->
    user.description = "#{user.first_name} #{user.last_name}"
    user.id ||= '' # Replace null id with empty string for the 'Nobody' option
    user.optionClass = 'users'
    user

  _usersGroups: ->
    usersGroups = _.clone(@groups)
    usersGroups = usersGroups.filter((group) -> group.show_in_customer)

    _.each(usersGroups, (userGroup) ->
      userGroup.id ||= ''
      userGroup.optionClass = 'groups'
    )
    usersGroups

  _notAssigned: ->
    {
      id: NO_TEAM_AND_NO_OPERATOR_ID,
      name: I18n.t('customer.dashboard.filters.no_team_nor_operator'),
      optionClass: 'groups'
    }


  _assignedUsers: ->
    (user for user in [
      'me' if @filter.get('query').assigned_to_me
      'robot' if @filter.get('query').assigned_to_robot
      'nobody' if '' in @filter.get('query').assigned_to_id
      @filter.get('query').assigned_to_id...
    ] when user?)

  updateAssignedTo: ->
    @filter.updateAssignedToId @assignedToView.selectedWithClass 'users'
    @filter.updateUsersGroupId @assignedToView.selectedWithClass 'groups'
    @filter.updateIsAssignedToMe @assignedToView.myselfIsSelected()
    @filter.updateIsAssignedToRobot @assignedToView.robotIsSelected()
